module.exports = ".group-edit .input-group-btn button {\n    margin: 0px;\n    margin-bottom: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/assessment-group-edit/assessment-group-edit.component.css
// module id = ./src/app/admin/assessment-group-edit/assessment-group-edit.component.css
// module chunks = main